var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEscapeReumColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 103,
    viewBox: "0 0 241 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1689_5812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52148 56.6289H21.6206V62.6643H13.9382V71.7173H20.7261V77.7526H13.9382V87.0133H21.7789V93.0486H7.52148V56.6289Z",
    fill: "url(#paint0_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3057 91.7983V85.1913C25.5693 86.491 27.3583 87.2191 29.0926 87.2191C30.9333 87.2191 32.5124 86.3346 32.5124 84.0961V83.9908C32.5124 82.327 31.986 81.0784 28.9344 77.6426C24.5683 72.7535 22.7793 70.4098 22.7793 65.9871V65.8818C22.7793 60.054 26.619 56.3594 31.7244 56.3594C34.3014 56.3594 35.8288 56.7234 37.4079 57.5027V64.1097C35.4089 62.9664 34.198 62.4459 32.5154 62.4459C30.7264 62.4459 29.2021 63.5892 29.2021 65.5689V65.6742C29.2021 67.3921 29.7285 68.0149 32.7801 71.5019C37.8308 77.2755 38.9352 79.5139 38.9352 83.6749V83.7802C38.9352 89.5027 34.8825 93.3026 29.8319 93.3026C27.3066 93.3026 25.1494 92.6768 23.3087 91.7952L23.3057 91.7983Z",
    fill: "url(#paint1_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5117 75.4601V74.2115C39.5117 61.4127 44.3007 56.3672 50.2975 56.3672C52.0866 56.3672 53.1393 56.5748 54.5054 57.2006V63.7564C53.191 62.9772 52.1383 62.559 50.9273 62.559C48.0856 62.559 46.0349 65.0562 46.0349 74.1603V75.5142C46.0349 85.1389 48.0856 87.1156 51.0338 87.1156C52.0348 87.1156 53.2975 86.7515 54.6119 85.9723V92.2152C53.1393 93.0486 51.7184 93.3074 49.8777 93.3074C43.9843 93.3074 39.5117 88.1566 39.5117 75.4631V75.4601Z",
    fill: "url(#paint2_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1864 56.5234H69.0261L76.0239 93.0484H69.6042L68.3932 85.8156H62.5515L61.3954 93.0484H55.1855L62.1834 56.5234H62.1864ZM67.447 80.0932L65.4998 68.0736L63.5008 80.0932H67.447Z",
    fill: "url(#paint3_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1797 56.6289H82.9149C89.9127 56.6289 94.8052 60.3747 94.8052 68.9072V69.0125C94.8052 77.2321 90.1744 81.1344 83.6512 81.6037H83.5995V93.0486H77.1797V56.6289ZM83.6512 75.7218C86.3347 75.5653 88.3854 73.6398 88.3854 69.2171V69.1118C88.3854 64.4815 86.5964 62.5048 83.8094 62.5048H83.5995V75.7188H83.6512V75.7218Z",
    fill: "url(#paint4_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6504 56.6289H110.75V62.6643H103.067V71.7173H109.855V77.7526H103.067V87.0133H110.908V93.0486H96.6504V56.6289Z",
    fill: "url(#paint5_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71 100.35H0V49.7266H114.71V51.5318H1.82553V98.5449H114.71V100.35Z",
    fill: "url(#paint6_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.828 101.02H128.442V84.9872H128.609L131.728 96.5314H133.8L130.145 83.0105H126.443V101.02H116.612V77.0083H114.613V103H145.827V77.0083H143.828V101.02ZM114.613 47V72.9857H116.612V66.9082H120.455V96.6066H122.454V64.9316H116.612V48.9767H143.828V72.9857H145.827V47H114.613Z",
    fill: "url(#paint7_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.454 54.9806H131.423C134.98 54.9806 137.983 57.8659 137.983 61.2807V76.5526C137.983 79.7689 137.013 81.8899 135.02 83.0423L134.36 83.4244L137.938 96.5331H139.982L136.678 84.333C138.872 82.7534 139.982 80.1419 139.982 76.5556V61.2837C139.982 56.7948 136.063 53.0039 131.423 53.0039H120.455V59.8907H122.454V54.9806Z",
    fill: "url(#paint8_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.766 59.003H126.299V78.9895H130.537C131.949 78.9895 133.172 78.1831 133.765 77.0068C134.006 76.5314 134.143 75.9898 134.143 75.4242V61.3498C134.143 60.056 133.078 59 131.766 59V59.003ZM132.144 75.4272C132.144 76.2727 131.468 76.9646 130.625 77.0098C130.598 77.0128 130.571 77.0128 130.54 77.0128H128.301V60.9797H131.769C131.976 60.9797 132.147 61.1452 132.147 61.3528V75.4272H132.144Z",
    fill: "url(#paint9_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.343 68.6094C156.338 68.6094 154.646 70.3213 154.646 72.3461V75.9896H162.055V72.3461C162.055 70.3213 160.354 68.6094 158.343 68.6094ZM160.056 74.0129H156.645V72.3491C156.645 71.4285 157.455 70.5891 158.343 70.5891C159.232 70.5891 160.056 71.4104 160.056 72.3491V74.0129Z",
    fill: "url(#paint10_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.877 79.4116H167.47V72.7053C167.47 67.2928 163.548 63.207 158.348 63.207C153.148 63.207 149.239 67.2928 149.239 72.7053V80.4015H151.238V72.7053C151.238 68.418 154.292 65.1837 158.348 65.1837C162.404 65.1837 165.471 68.418 165.471 72.7053V79.4116H154.648V88.6211C154.648 90.5918 156.31 92.1924 158.348 92.1924C160.387 92.1924 162.06 90.5918 162.06 88.6211V85.802H160.061V88.6211C160.061 89.4846 159.276 90.2157 158.348 90.2157C157.42 90.2157 156.647 89.4846 156.647 88.6211V81.3883H170.877V101.02H145.831V86.7918H149.226V88.0916C149.226 93.4199 153.233 97.5959 158.348 97.5959C163.463 97.5959 167.47 93.5102 167.47 88.0916V85.802H165.471V88.0916C165.471 92.3819 162.407 95.6162 158.348 95.6162C154.289 95.6162 151.225 92.3819 151.225 88.0916V84.8121H145.831V77.0047H143.832V102.996H172.879V77.0047H170.88V79.4086L170.877 79.4116Z",
    fill: "url(#paint11_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.828 47V72.9857H145.827V48.9767H149.235V59.7807H156.646V54.3802H166.468V52.4035H154.647V57.8041H151.234V48.9767H170.876V57.8041H161.058V59.7807H170.876V72.9857H172.875V47H143.828Z",
    fill: "url(#paint12_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.924 47V72.9857H199.926V59.7807H211.67V53.3904H209.671V57.8041H199.926V48.9767H215.537V58.7939H217.539V54.3802H228.267V52.4035H217.539V48.9767H233.135V57.8041H228.267V59.7807H235.134V48.9767H239.001V72.9857H241V47H197.924Z",
    fill: "url(#paint13_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.002 95.621H235.135V91.2073H233.136V97.5977H239.002V101.022H229.269V70.4055C229.269 69.4157 228.454 68.6094 227.453 68.6094H221.407V96.5778H223.406V70.5861H227.27V101.022H217.54V70.4055C217.54 69.4157 216.725 68.6094 215.721 68.6094H209.675V96.641H211.674V70.5861H215.541V101.022H199.927V77.0095H197.928V103.001H241.004V77.0095H239.005V95.621H239.002Z",
    fill: "url(#paint14_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.135 85.8015V70.5808C235.135 66.3175 231.627 62.8516 227.318 62.8516H203.809V96.6357H205.808V64.8282H227.318C230.525 64.8282 233.136 67.4097 233.136 70.5808V85.8015H235.135Z",
    fill: "url(#paint15_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.877 47V72.9857H172.876V54.3802H181.699V59.7838H183.698V52.4035H172.876V48.9767H187.106V59.7807H193.517V57.8041H189.105V48.9767H197.928V63.2046H192.242V88.6517C192.242 92.4547 189.111 95.5536 185.268 95.5536C181.425 95.5536 178.289 92.4577 178.289 88.6517V59.7807H176.29V88.6548C176.29 93.5498 180.318 97.5333 185.268 97.5333C190.218 97.5333 194.244 93.5498 194.244 88.6548V65.1843H197.931V72.9857H199.93V47H170.88H170.877Z",
    fill: "url(#paint16_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.925 101.02H172.876V77.0078H170.877V103H199.927V77.0078H197.925V101.02Z",
    fill: "url(#paint17_radial_1689_5812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.693 64.1953V88.5323C181.693 90.5511 183.355 92.1968 185.399 92.1968C187.444 92.1968 189.105 90.5541 189.105 88.5323V64.1953H187.106V88.5323C187.106 89.462 186.342 90.2171 185.402 90.2171C184.462 90.2171 183.698 89.462 183.698 88.5323V64.1953H181.699H181.693Z",
    fill: "url(#paint18_radial_1689_5812)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.967 14.9744C123.599 14.3419 124 13.4701 124 12.5043C123.991 10.5726 122.438 9.00855 120.509 9H120.5H120.457C118.554 9.01709 117.017 10.5641 117 12.4786V12.5214C117.017 14.4359 118.562 15.9829 120.474 16C120.483 16 120.491 16 120.5 16C121.465 16 122.335 15.6068 122.967 14.9744Z",
    fill: "#FFDD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.452 0.340246C139.236 0.126603 138.923 0 138.603 0H120.402C116.919 0 113.764 1.39263 111.49 3.64775C109.208 5.90286 107.798 9.01255 107.79 12.4546C107.79 12.4625 107.79 12.4625 107.79 12.4704C107.79 13.5861 107.942 14.6701 108.223 15.7067H105.66C103.098 15.7067 101.016 17.7482 101 20.2802V20.2881C101 20.296 101 20.296 101 20.296C101 20.3198 101 20.3435 101.008 20.3752V23.7381C101.008 24.0546 101.136 24.3553 101.352 24.5768C101.577 24.7984 101.889 24.925 102.201 24.925H120.41C127.377 24.9171 133.014 19.3465 133.022 12.4625V12.4546C133.022 11.3389 132.87 10.2548 132.589 9.21828H135.144C137.722 9.21828 139.812 7.15307 139.812 4.60518V1.17108C139.804 0.862483 139.676 0.561801 139.452 0.340246ZM130.628 12.4704C130.62 15.2636 129.483 17.7719 127.633 19.5997C125.775 21.4276 123.229 22.5591 120.402 22.5591H103.386L103.394 20.3356C103.394 20.3119 103.394 20.2723 103.394 20.2407C103.434 19.03 104.435 18.0568 105.668 18.0568H120.402C120.426 18.0568 120.45 18.0568 120.474 18.0488C123.573 18.0093 126.063 15.5168 126.063 12.4546V12.4229C126.055 11.2281 125.671 10.1203 125.022 9.21828H130.083C130.427 10.2232 130.62 11.2993 130.62 12.4229C130.628 12.4387 130.628 12.4546 130.628 12.4704ZM117.119 12.4783V12.4387C117.135 10.6663 118.576 9.23411 120.362 9.21828H120.402H120.41C122.22 9.22619 123.677 10.6663 123.685 12.4625C123.685 13.3566 123.309 14.1637 122.716 14.7492C122.124 15.3348 121.307 15.6988 120.402 15.6988C120.394 15.6988 120.386 15.6988 120.378 15.6988C118.584 15.6829 117.135 14.2587 117.119 12.4783ZM137.41 4.5498C137.41 4.57353 137.41 4.60518 137.41 4.62101C137.402 5.85539 136.385 6.8603 135.128 6.8603H120.41H120.402H120.354C117.271 6.88404 114.781 9.33697 114.733 12.3754C114.725 12.4308 114.725 12.4704 114.733 12.502C114.741 13.6969 115.125 14.7967 115.774 15.7067H110.713C110.369 14.7018 110.177 13.6256 110.177 12.502C110.185 12.4783 110.185 12.4467 110.177 12.4229C110.193 9.64557 111.33 7.14516 113.179 5.31733C115.029 3.4895 117.575 2.35798 120.41 2.35798H137.418V4.5498H137.41Z",
    fill: "#004C78"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6692 75.1751) rotate(-25.1972) scale(32.3957 39.4605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8788 75.1722) rotate(-22.8399) scale(36.0425 40.7685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0819 75.1785) rotate(-24.256) scale(34.0521 40.3284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.6325 75.1233) rotate(-17.8923) scale(45.0212 41.6209)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.0159 75.1751) rotate(-20.8365) scale(38.7738 40.758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.798 75.1751) rotate(-25.1972) scale(32.3956 39.4605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.508 75.5059) rotate(-4.64714) scale(236.622 60.4189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.262 75.5172) rotate(-18.2864) scale(67.5881 63.6698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.245 75.1705) rotate(-22.3226) scale(43.4 48.217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.231 69.1794) rotate(-25.1455) scale(17.8149 21.6676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.361 72.3677) rotate(-10.3972) scale(15.4864 8.6922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.394 83.4692) rotate(-14.1606) scale(61.5926 46.1973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.39 60.2329) rotate(-9.35695) scale(60.5263 30.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.519 60.2329) rotate(-6.34025) scale(89.11 30.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.523 86.123) rotate(-8.36573) scale(89.5175 40.7437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.513 80.0557) rotate(-11.2351) scale(65.6648 39.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.442 72.7334) rotate(-17.7638) scale(62.724 57.6251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.441 90.2437) rotate(-9.35811) scale(60.5329 30.7091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1689_5812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.409 78.4547) rotate(-34.8332) scale(18.5648 27.522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1689_5812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 56,
    fill: "white",
    transform: "translate(0 47)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEscapeReumColor);
export default __webpack_public_path__ + "static/media/logo-EscapeReum-color.867fc79483c1431bc5e434045ca220f8.svg";
export { ForwardRef as ReactComponent };